import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-dispatch-widget-loader',
  templateUrl: './dispatch-widget-loader.component.html',
  styleUrls: ['./dispatch-widget-loader.component.scss']
})
export class DispatchWidgetLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
